import { Expose } from 'class-transformer';
import { Model } from './model';

export class CurrentCallsChart extends Model {
  @Expose({ name: 'BusyTeacherCountFemale' }) countOfInCallFemaleTeachers: number;
  @Expose({ name: 'BusyTeacherCountMale' }) countOfInCallMaleTeachers: number;
  @Expose({ name: 'busyTeacherFemaleChangeRate' }) changeRateOfInCallFemaleTeachers: number;
  @Expose({ name: 'busyTeacherMaleChangeRate' }) changeRateOfInCallMaleTeachers: number;
}
